(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .service('BrandService', BrandService);

    BrandService.$inject = ['BrandFactoryAdmin'];

    function BrandService(BrandFactoryAdmin) {
        var service = {
            getBrandsByCurrentStore: getBrandsByCurrentStore,
            findBrand: findBrand,
            createBrand: createBrand,
            getBrandById: getBrandById,
            removeBrand: removeBrand,
            editBrand: editBrand
        };

        return service;

        function getBrandsByCurrentStore() {
            return BrandFactoryAdmin.getBrandsByCurrentSTore().$promise;
        }

        function findBrand(brandName,  page, size) {
            return BrandFactoryAdmin.findBrand( { name: brandName, page: page, size: size } ).$promise;
        }

        function createBrand(brand) {
            return BrandFactoryAdmin.createBrand({ "name": brand.name, "logo": brand.logo }).$promise;
        }

        function getBrandById(brandId) {
            return BrandFactoryAdmin.getBrandById({"brandId": brandId}).$promise;
        }

        function removeBrand(brandId) {
            return BrandFactoryAdmin.removeBrand({"brandId": brandId}).$promise;
        }

        function editBrand(brand) {
            return BrandFactoryAdmin.editBrand({"brandId": brand.id}, brand).$promise;
        }

    }
})();
